// extracted by mini-css-extract-plugin
export var sponsorTier = "index-module--sponsorTier--3QOvT";
export var sponsor = "index-module--sponsor--3WfP0";
export var sponsorLogo = "index-module--sponsorLogo--3y_id";
export var sponsorButtonContainer = "index-module--sponsorButtonContainer--1FO3v";
export var tier = "index-module--tier--1UsO0";
export var tier1 = "index-module--tier1--2fwLs";
export var tier2 = "index-module--tier2--1LoIE";
export var tier3 = "index-module--tier3--33Mo-";
export var tier4 = "index-module--tier4--1Tf9H";